// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChapterListController from "./chapter_list_controller"
application.register("chapter-list", ChapterListController)

import ChartjsController from "./chartjs_controller"
application.register("chartjs", ChartjsController)

import ColorChangerController from "./color_changer_controller"
application.register("color-changer", ColorChangerController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownNativeController from "./dropdown_native_controller"
application.register("dropdown-native", DropdownNativeController)

import FileDetailController from "./file_detail_controller"
application.register("file-detail", FileDetailController)

import FileNodeNameController from "./file_node_name_controller"
application.register("file-node-name", FileNodeNameController)

import FormResponderController from "./form_responder_controller"
application.register("form-responder", FormResponderController)

import GlobalNotificationController from "./global_notification_controller"
application.register("global-notification", GlobalNotificationController)

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import HighlightableController from "./highlightable_controller"
application.register("highlightable", HighlightableController)

import IphoneStaticController from "./iphone_static_controller"
application.register("iphone-static", IphoneStaticController)

import ModalDialogController from "./modal_dialog_controller"
application.register("modal-dialog", ModalDialogController)

import ModalDialogTriggerController from "./modal_dialog_trigger_controller"
application.register("modal-dialog-trigger", ModalDialogTriggerController)

import OptionListController from "./option_list_controller"
application.register("option-list", OptionListController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import RadioButtonController from "./radio_button_controller"
application.register("radio-button", RadioButtonController)

import RevealerController from "./revealer_controller"
application.register("revealer", RevealerController)

import SelectMenuController from "./select_menu_controller"
application.register("select-menu", SelectMenuController)

import SidePanelOpenerController from "./side_panel_opener_controller"
application.register("side-panel-opener", SidePanelOpenerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SlideDrawerController from "./slide_drawer_controller"
application.register("slide-drawer", SlideDrawerController)

import SlideDrawerTriggerController from "./slide_drawer_trigger_controller"
application.register("slide-drawer-trigger", SlideDrawerTriggerController)

import SlideDrawerZustandController from "./slide_drawer_zustand_controller"
application.register("slide-drawer-zustand", SlideDrawerZustandController)

import SwitchController from "./switch_controller"
application.register("switch", SwitchController)

import TiersWithToggleController from "./tiers_with_toggle_controller"
application.register("tiers-with-toggle", TiersWithToggleController)

import TodoController from "./todo_controller"
application.register("todo", TodoController)

import TodoLikesController from "./todo_likes_controller"
application.register("todo-likes", TodoLikesController)

import ValidatorController from "./validator_controller"
application.register("validator", ValidatorController)

import VariantsSelectorController from "./variants_selector_controller"
application.register("variants-selector", VariantsSelectorController)
